import { gql } from "@apollo/client";

export const CREATE_LENDERS = gql`
mutation createLender(
    $arcimedes_row_id: ID,
    $name: String!,
    $city: String,
    $state : String,
    $contact_name :String,
    $contact_phone :String,
    $contact_email :String,
    $deleted :Int,
    $notes :String
) {
    createOrUpdateLender(input: {
        arcimedes_row_id: $arcimedes_row_id
        name: $name
        city: $city
        state: $state
        contact_name: $contact_name
        contact_phone: $contact_phone
        contact_email: $contact_email
        deleted: $deleted
        notes: $notes
    }) {
        lender {
            arcimedes_row_id
            name
            city
            state
            contact_name
            contact_phone
            contact_email
            deleted
            notes
            arcimedes_created
            arcimedes_created_by
            arcimedes_modified
            arcimedes_modified_by
        }
    }
}
`
export const CREATE_UPDATE_LENDERS = gql`
mutation createOrUpdateLenders($input: [LenderInput]!) {
    createOrUpdateLenders(input: $input) {
        data {
            ARCIMEDES_ROW_ID
            NAME
            CITY
            STATE
            CONTACT_NAME
            CONTACT_PHONE
            CONTACT_EMAIL
            DELETED
            NOTES
          }
    }
}`